export const SHOWMSG_MSG_SUCCESS = 'SHOWMSG_MSG_SUCCESS';
export const SHOWMSG_MSG_DANGER = 'SHOWMSG_MSG_DANGER';
export const SHOWMSG_RESET = 'SHOWMSG_RESET';
export const LOADING = 'LOADING';